<template>
  <ErrorModal />
  <q-dialog v-model="shareGrantsPage" class="share-grants-page">
    <q-card class="share-dialog">
      <q-form
        @submit="
          shareSchemePageEmit(
            address,
            message,
            description,
            reportTitle,
            customerName,
            customerAccountName
          )
        "
      >
        <q-card-section>
          <div class="text-h5">Deel geselecteerde items als een rapport</div>
        </q-card-section>
        <q-card-section>
          <div class="column justify-between top-section-responsive">
            <div class="column column-width">
              <span class="input-heading">
                Rapporttitel *
              </span>
              <q-input
                class="q-mt-sm"
                outlined
                v-model="reportTitle"
                dense
                :rules="requiredFieldRule"
              />

              <span class="input-heading q-mt-md">
                Omschrijving
              </span>
              <q-input
                class="q-mt-sm"
                v-model="description"
                outlined
                type="textarea"
              />
            </div>

            <q-separator class="q-mt-md fullwidth-seperator" />
            <div class="column column-width">
              <div class="text-h5 q-mt-sm">Ontvanger(s)</div>

              <span class="input-heading q-mt-sm"> Naam</span>
              <q-input class="q-mt-sm" outlined v-model="customerName" dense />
              <span class="input-heading q-mt-md"> Organisatienaam</span>
              <q-input
                class="q-mt-sm"
                outlined
                v-model="customerAccountName"
                dense
              />
            </div>
          </div>
        </q-card-section>
        <q-card-section class="bottom-heading">
          <q-input
            class="q-mt-sm column-width"
            outlined
            v-model="address"
            dense
            type="email"
            :rules="[isValidEmail, requiredFieldRule]"
            label="Voeg een e-mailadres toe"
          />
        </q-card-section>

        <q-card-section>
          <div class="share-text-sm">
            <span class="share-info">
              Bericht *
            </span>
            <q-input
              :rules="requiredFieldRule"
              class="q-mt-sm"
              v-model="message"
              outlined
              type="textarea"
            />
          </div>
        </q-card-section>

        <q-card-section class="report-type">
          <q-select
            square
            outlined
            v-model="reportType"
            :options="options"
            label="Type rapport"
            style="width: 47%"
          />
        </q-card-section>

        <q-card-actions class="q-mt-sm" align="left">
          <q-btn
            flat
            no-caps
            label="Delen"
            class="submit-btn"
            color="white"
            type="submit"
          />
          <q-btn
            no-caps
            flat
            label="Annuleren"
            class="cancel-btn"
            v-close-popup
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from 'vue';
import store from '../../store/index';
import MailingService from '../../services/mailing.service';
import ErrorModal from './ErrorModal.vue';

export default {
  components: { ErrorModal },
  setup() {
    const shareGrantsPage = computed({
      get: () => store.state.grantItems.shareGrantsPage,
      set: (val) => store.commit('grantItems/disableShareGrantsPage', val),
    });
    const grant = computed({
      get: () => store.state.grantItems.grantToShare,
    });
    const selectedResultsIds = computed({
      get: () => store.state.grantItems.selectedResults.map((r) => r.schemeId),
    });
    const shareSchemePageEmit = async (
      address,
      message,
      description,
      reportTitle,
      customerName,
      customerAccountName
    ) => {
      MailingService.shareSchemes(
        address,
        message,
        description,
        reportTitle,
        customerName,
        customerAccountName,
        selectedResultsIds.value
      );
    };
    const address = ref('');
    const message = ref('');
    const reportTitle = ref('');
    const description = ref('');
    const customerName = ref('');
    const reportTemplate = ref('');
    const templateOptions = ['Template 1', 'Template 2'];
    const searchCriteria = ref('');
    const customerAccountName = ref('');

    const reportType = ref('Volledig rapport');

    return {
      options: [
        'Volledig rapport',
        /*     'Kerngegevens en samenvattingen',
        'Alleen kerngegevens', */
      ],

      reportType,
      customerAccountName,
      selectedResultsIds,
      searchCriteria,
      templateOptions,
      reportTemplate,
      customerName,
      description,
      reportTitle,
      message,
      address,
      shareSchemePageEmit,
      shareGrantsPage,
      grant,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },
    };
  },
};
</script>
